import React from 'react';
import { BookOpen, ListOrdered, MessageCircle, FileText, Layers, Download } from 'lucide-react';
export function IncludesSection() {
  return <section className="bg-[#1e3a5a] text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-78">
      <div className="max-w-6xl mx-auto" data-id="element-79">
        <div className="text-center mb-16" data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-81">
            Qué incluye exactamente
          </h2>
          <h3 className="text-2xl md:text-3xl font-extrabold text-[#d4a853]" data-id="element-82">
            POLÍTICA Y CIUDADANÍA 360
          </h3>
          <p className="mt-4 text-blue-200" data-id="element-83">
            Un pack educativo digital completo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-84">
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-85">
            <BookOpen className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-86" />
            <h4 className="text-xl font-bold mb-2" data-id="element-87">Clases anuales completas</h4>
            <p className="text-blue-100 text-sm" data-id="element-88">
              Todo el contenido del año estructurado y listo para impartir.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-89">
            <ListOrdered className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-90" />
            <h4 className="text-xl font-bold mb-2" data-id="element-91">
              Secuencia pedagógica clara
            </h4>
            <p className="text-blue-100 text-sm" data-id="element-92">
              Orden lógico y progresivo para que los alumnos no se pierdan.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-93">
            <MessageCircle className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-94" />
            <h4 className="text-xl font-bold mb-2" data-id="element-95">Explicaciones listas</h4>
            <p className="text-blue-100 text-sm" data-id="element-96">
              Conceptos bajados a tierra para usar directamente en clase.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-97">
            <FileText className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-98" />
            <h4 className="text-xl font-bold mb-2" data-id="element-99">Actividades de debate</h4>
            <p className="text-blue-100 text-sm" data-id="element-100">
              Propuestas concretas que generan participación genuina.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-101">
            <Layers className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-102" />
            <h4 className="text-xl font-bold mb-2" data-id="element-103">
              Contenidos para secundaria
            </h4>
            <p className="text-blue-100 text-sm" data-id="element-104">
              Pensados específicamente para la realidad adolescente.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition duration-300" data-id="element-105">
            <Download className="w-10 h-10 text-[#d4a853] mb-4" data-id="element-106" />
            <h4 className="text-xl font-bold mb-2" data-id="element-107">Material editable</h4>
            <p className="text-blue-100 text-sm" data-id="element-108">
              Archivos organizados que podés adaptar si lo necesitás.
            </p>
          </div>
        </div>

        <div className="text-center bg-[#d4a853] text-[#1e3a5a] p-6 rounded-xl font-bold text-xl shadow-lg transform hover:scale-105 transition duration-300" data-id="element-109">
          No es teoría acumulada. Es aula real resuelta.
        </div>
      </div>
    </section>;
}